import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import logo from "../images/amotive-orange-revert.png";
import logoInvert from "../images/sud-ricambi-logo-symbol-white.png";
import logoInvert2 from "../images/TP-_logo-symbol-white.png";
import logoInvert3 from "../images/logo_proforma-removebg-preview (1).png";
import { IoIosArrowForward } from "react-icons/io";
import { FaUnlock } from "react-icons/fa";
import { FaLock } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { FaBell } from "react-icons/fa";
import logoQlik from "../images/qlik2.png";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Modal, Button } from "react-bootstrap";
import { FaMapMarkerAlt } from "react-icons/fa";
import { FaUser } from "react-icons/fa";
import { FaBars } from "react-icons/fa";
import { RiMoneyEuroCircleFill } from "react-icons/ri";


function BasicExample() {
  const [isLocked, setIsLocked] = useState(() => {
    const lockedState = localStorage.getItem("isLocked");
    return lockedState ? JSON.parse(lockedState) : true;
  });
  const [showMap, setShowMap] = useState(false);
  const handleShowMap = () => setShowMap(true);
  const handleCloseMap = () => setShowMap(false);

  const exportToExcel = () => {
    if (!downloads.length) return;

    // Prepara i dati da esportare
    const dataToExport = filteredDownloads.map((item) => ({
      "Ragione Sociale": item.ragione_sociale,
      "Nome File": item.nome_file,
      Data: new Date(item.quando).toLocaleDateString(),
    }));

    // Crea un worksheet e un workbook
    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Downloads");

    // Genera file Excel e scarica
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "downloads.xlsx");
  };

  const handleLockClick = () => {
    setIsLocked(!isLocked);
  };



  useEffect(() => {
    localStorage.setItem("isLocked", JSON.stringify(isLocked));
  }, [isLocked]);

  useEffect(() => {
    let intervalId;

    if (!isLocked) {
      intervalId = setInterval(() => {
        window.location.reload();
      }, 150000);
    } else {
      intervalId = setInterval(() => {
        window.location.href = "/amotive";
      }, 150000);
    }

    return () => clearInterval(intervalId);
  }, [isLocked]);

  const [downloads, setDownloads] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const filteredDownloads = downloads.filter((item) =>
    item.ragione_sociale?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    fetch("mancata_vendita_dashboard.json")
      .then((res) => res.json())
      .then((data) => {
        console.log("Dati ricevuti:", data);

        if (data?.TP?.download && Array.isArray(data.TP.download)) {
          setDownloads(data.TP.download); // Usa direttamente l'array
        } else {
          console.warn("Struttura download non valida:", data?.TP?.download);
        }
      })
      .catch((err) => console.error("Errore fetch:", err));
  }, []);

return (
  <Navbar
    expand="lg"
    className="navbar-desktop full-width-navbar shadow p-0 sticky-navbar navbar-heigth rounded-pill m-3 mb-0 mt-2"
    style={{
      background:
        "rgba(241,111,36,1)",
      padding: "18px 28px",
      maxHeight: "55px",
      display: "flex",
      alignItems: "center"
    }}
  >
    <Container fluid className="p-0 d-flex align-items-center">
      {/* LOGO + UTENTI ONLINE */}
      <Navbar.Brand
        href="#home"
        className="fs-3 fw-bold mx-3 d-flex align-items-center"
      >
        <img
          alt=""
          src={logo}
          className="d-inline-block align-middle"
          style={{ maxWidth: "100px" }}
        />

       
      </Navbar.Brand>

      {/* HAMBURGER */}
      <Navbar.Toggle aria-controls="navbar-responsive" className="me-3 border-0">
        <FaBars className="text-white fs-3" />
      </Navbar.Toggle>

      {/* MENU DESTRO */}
      <Navbar.Collapse id="navbar-responsive" className="justify-content-end">
        <div
          className="
            d-flex flex-column flex-lg-row
            align-items-start align-items-lg-center
            gap-4 py-3 me-3
          "
        >
          {/* ESPOSIZIONE */}
          <Link to="/esposizione" className="text-light text-decoration-none">
            <div className="d-flex align-items-center">
              <RiMoneyEuroCircleFill className="fs-4 me-2" />
              <span>ESPOSIZIONE</span>
            </div>
          </Link>

          {/* QLIK */}
          <a
            href="https://dashboard.technoparts.it/qlik/ar.html"
            target="_blank"
            rel="noopener noreferrer"
            className="text-light text-decoration-none"
          >
            <div className="d-flex align-items-center">
              <img
                alt="Qlik"
                src={logoQlik}
                className="me-2"
                style={{ maxWidth: "26px" }}
              />
              <span>QLIK</span>
            </div>
          </a>

          {/* SUD RICAMBI */}
          <Link to="/sud-ricambi" className="text-light text-decoration-none">
            <div className="d-flex align-items-center">
              <img
                alt="Sud Ricambi"
                src={logoInvert}
                className="me-2"
                style={{ maxWidth: "30px" }}
              />
              <span>SUD RICAMBI</span>
            </div>
          </Link>

          {/* TECHNOPARTS */}
          <Link to="/technoparts" className="text-light text-decoration-none">
            <div className="d-flex align-items-center">
              <img
                alt="Technoparts"
                src={logoInvert2}
                className="me-2"
                style={{ maxWidth: "20px" }}
              />
              <span>TECHNOPARTS</span>
            </div>
          </Link>

          {/* Separatore */}
          <div
            style={{
              width: "1px",
              height: "30px",
              backgroundColor: "rgba(255,255,255,0.9)",
            }}
          ></div>

          {/* LOCK */}
          <div className="toggle-button-cover-2 mt-lg-0 mt-2">
            <div id="button-3-2" className="button r">
              <input
                className="checkbox-2"
                type="checkbox"
                checked={isLocked}
                onChange={handleLockClick}
              />
              <div className="knobs-2"></div>
              <div className="layer-2"></div>
              <span className="lock-icon-2" isLocked={isLocked}>
                {isLocked ? (
                  <FaUnlock className="text-dark fs-6" />
                ) : (
                  <FaLock className="text-dark fs-6" />
                )}
              </span>
            </div>
          </div>
        </div>
      </Navbar.Collapse>
    </Container>
  </Navbar>
);

}

export default BasicExample;
